import { EntityClassTypes } from 'models'

export const getEntityClass = entity => {
  return entity.hasOwnProperty('brandId') ? EntityClassTypes.PRODUCT : EntityClassTypes.PERSON
}
